import { combineReducers } from 'redux';

import genericOptionsReducer from './genericOptions/reducer';
import servicesReducer from './services/reducer';
import sessionReducer from './session/reducer';

const rootReducer = combineReducers({
  session: sessionReducer,
  options: genericOptionsReducer,
  services: servicesReducer,
});

export default rootReducer;
